export const SPECIAL_FIELD_MAPPINGS: Record<string, string> = {
  'kol(': 'kol_wallets',
  'ca(': 'ca_caller_ids',
}
